import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";

import { IoIosArrowDown } from "react-icons/io";
import { Link } from "react-router-dom";
import LoaderMini from "../../../Loader/LoaderMini";
import logo from "../../../../assets/icons/Logo_Full.webp";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

// import logo_ar from "../../../../assets/icons/logo_full_arabic.png";



export const MobileNav = ({
  handlePopup,
  isAuthenticated,
  user,
  handleLogout,
}) => {
  const { t, i18n } = useTranslation();
  const isEng = i18n.language === "en";
  const [toggleNav, setToggleNav] = useState(false);
  const navRef = useRef(null);
  const menuButtonRef = useRef(null);
  const [showOccasions, setShowOccasions] = useState(false);
  const [showLanguages, setShowLanguages] = useState(false);
  const { catalogs, loading: catalogsLoading } = useSelector(
    (state) => state.catalogs
  );
  const { categories, loading: categoriesLoading } = useSelector(
    (state) => state.categories
  );

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        navRef.current &&
        !navRef.current.contains(e.target) &&
        menuButtonRef.current &&
        !menuButtonRef.current.contains(e.target)
      ) {
        setToggleNav(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleToggleNav = () => {
    setToggleNav((prev) => !prev);
  };

  const handleToggleOccasions = () => {
    setShowOccasions((prev) => !prev);
  };
  const handleToggleLanguages = () => {
    setShowLanguages((prev) => !prev);
  };

  const menuVars = {
    initial: { opacity: 1, width: 0, x: i18n.language === "en" ? -100 : 100 },
    animate: {
      opacity: 1,
      width: toggleNav ? "18rem" : 0,
      x: toggleNav ? 0 : i18n.language === "en" ? 100 : -100,
      transition: {
        duration: 0.7,
      },
    },
    exit: {
      opacity: 1,
      width: 0,
      x: i18n.language === "en" ? -100 : 100,
      transition: {
        duration: 0.7,
        delay: 0.2,
      },
    },
  };

  return (
    <div className="md:hidden whitespace-nowrap text-[#402D7E]">
      {/* menu button */}
      <motion.button
        whileHover={{ scale: 1.2 }}
        whileTap={{ scale: 0.9 }}
        transition={{
          type: "spring",
          stiffness: 400,
          damping: 17,
        }}
        ref={menuButtonRef}
        onClick={handleToggleNav}
        className={`md:hidden flex flex-col items-center justify-center space-y-1 z-40 ${toggleNav ? "" : "sticky"
          }`}
        // z-index doesn't work on static positions
        animate={toggleNav ? "open" : "closed"}
      >
        <motion.span
          className={`h-[0.10rem] w-7 rounded-2xl bg-[#402D7E] shadow-lg shadow-white relative ${toggleNav && "bg-[#402D7E]"
            }`}
          variants={{
            closed: { opacity: 1, rotate: "0deg" },
            open: {
              opacity: 1,
              rotate: "-45deg",
              y: 5,
            },
          }}
        ></motion.span>
        <motion.span
          className={`h-[0.10rem] w-7 rounded-2xl bg-[#402D7E] shadow-lg shadow-white ${toggleNav && "bg-[#402D7E]"
            }`}
          variants={{
            closed: { opacity: 1, rotate: "0deg", y: 0 },
            open: {
              opacity: 1,
              rotate: "45deg",
              y: 0,
            },
          }}
        ></motion.span>
        <motion.span
          className={`h-[0.10rem] w-7 rounded-2xl bg-[#402D7E] shadow-lg shadow-white ${toggleNav && "bg-[#402D7E]"
            }`}
          variants={{
            closed: { opacity: 1, rotate: "0deg" },
            open: {
              opacity: 0,
              rotate: "0deg",
            },
          }}
        ></motion.span>
      </motion.button>
      {/* menu */}
      <AnimatePresence>
        {toggleNav && (
          <motion.div className="z-50" ref={navRef}>
            <motion.div
              variants={menuVars}
              initial="initial"
              animate="animate"
              exit="exit"
              className={`fixed z-40  top-0 h-screen w-[18rem] bg-white 
              flex items-start justify-start flex-col md:hidden backdrop-blur-md 
               px-2 py-4 
              ${i18n.language === "en" ? "left-0" : "right-0"}`}
            >
              <div className="flex flex-col w-full h-full items-start justify-start relative">
                <motion.div
                  className="flex flex-col items-start justify-start w-full 
                 relative px-2 overflow-hidden"
                >
                  {/* Start-logo */}
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{
                      duration: 0.5,
                      delay: 0.2,
                    }}
                    className="flex items-center justify-center cursor-pointer 
                  group relative px-2 mb-3"
                  >
                    <Link
                      to="/"
                      onClick={() => {
                        setToggleNav(false);
                      }}
                      className="mb-5"
                    >
                      <motion.div
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}
                        transition={{
                          type: "spring",
                          damping: "17",
                          stiffness: "400",
                        }}
                      >
                        <img
                          src={isEng ? logo : logo}
                          alt="spring rose-زهرة الربيع"
                          className="h-[32px] object-cover"
                        />
                      </motion.div>
                    </Link>
                  </motion.div>
                  {/* End-logo */}

                  <p>{ }</p>

                  {/* menu items */}
                  {/* Start-Home */}
                  <motion.div>
                    <motion.div>
                      <motion.div
                        className="relative group flex items-center justify-center 
                     transition-all mb-5"
                      >
                        <Link
                          onClick={() => {
                            setToggleNav(false);
                          }}
                          to="/"
                          className={`flex items-center justify-center gap-1 px-2 
                      ease-in-out duration-100`}
                        >
                          <p className="">{t("home")}</p>
                        </Link>
                      </motion.div>
                    </motion.div>
                  </motion.div>
                  {/* End-Home */}
                  {/* Occasions */}
                  <motion.div className=" flex relative items-center justify-center w-full">
                    <motion.div
                      className={`flex items-center justify-between relative 
                      w-full  ${showOccasions ? "mb-2" : "mb-5"}`}
                    >
                      <motion.div
                        className={` flex items-center justify-center 
                     h-full transition-all px-2 group `}
                      >
                        <Link
                          onClick={handleToggleOccasions}
                          className={`flex items-center justify-center gap-1  
                      ease-in-out duration-100 h-full`}
                        >
                          <p className="">{t("occasions")}</p>
                        </Link>
                      </motion.div>
                      <motion.div
                        animate={{ rotate: showOccasions ? "180deg" : "0deg" }}
                        className="flex items-center justify-center"
                      >
                        <button onClick={handleToggleOccasions}>
                          <IoIosArrowDown />
                        </button>
                      </motion.div>
                    </motion.div>
                  </motion.div>
                  <AnimatePresence>
                    {showOccasions ? (
                      <motion.div
                        initial={{ opacity: 0, height: 0 }}
                        animate={{
                          opacity: 1,
                          height: 230,
                          transition: {
                            duration: 0.5,
                          },
                        }}
                        layout="true"
                        exit={{ opacity: 0, height: 0 }}
                        transition={{
                          duration: 0.5,
                        }}
                        className={`flex flex-col items-start justify-start w-full 
                       h-full ${i18n.language === "en" ? " pl-10 " : "pr-10"} `}
                      >
                        <div
                          className="flex flex-col items-start justify-start w-full 
                         h-full mb-3 gap-1"
                        >
                          {catalogsLoading ? (
                            <div className="flex items-center justify-center">
                              <LoaderMini color="bg-blue-500" />
                            </div>
                          ) : (
                            catalogs.map((catalog) => (
                              <div
                                key={catalog.id}
                                className="flex items-center justify-center"
                              >
                                <Link
                                  to={`/catalogs/${catalog.id}`}
                                  onClick={() => setToggleNav(false)}
                                >
                                  <button className={``}>
                                    {i18n.language === "en"
                                      ? catalog.english_name
                                      : catalog.arabic_name}
                                  </button>
                                </Link>
                              </div>
                            ))
                          )}
                        </div>
                      </motion.div>
                    ) : null}
                  </AnimatePresence>

                  {categoriesLoading ? (
                    <div className="flex items-center justify-center">
                      <LoaderMini color="bg-blue-500" />
                    </div>
                  ) : (
                    <div className="flex items-center justify-center flex-col">
                      {categories.map((category) => (
                        <div
                          key={category.id}
                          className=" flex relative items-center justify-center w-full bg-white"
                        >
                          <motion.div
                            key={category.id}
                            className="flex items-center justify-between relative w-full 
                    mb-5 "
                          >
                            <motion.div
                              className=" flex items-center justify-center 
                    overflow h-full transition-all px-2 group"
                            >
                              <Link
                                to={`/categories/${category.id}`}
                                onClick={() => setToggleNav(false)}
                                className={`flex items-center justify-center gap-1  
                      ease-in-out duration-100 h-full`}
                              >
                                <p className={`whitespace-nowrap `}>
                                  {i18n.language === "en"
                                    ? category.english_name
                                    : category.arabic_name}
                                </p>
                              </Link>
                            </motion.div>
                          </motion.div>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* language */}
                  <div className="flex relative items-center justify-center w-full">
                    <motion.div className="flex items-center justify-between relative w-full mb-3">
                      <motion.div
                        className=" flex items-center justify-center 
                    overflow h-full transition-all px-2 group"
                      >
                        <div
                          to="/categories"
                          onClick={() => setToggleNav(false)}
                          className={`flex items-center justify-center gap-1  
                      ease-in-out duration-100 h-full`}
                        >
                          <p className="">{t("language")}</p>
                        </div>
                      </motion.div>
                      <motion.div
                        animate={{ rotate: showLanguages ? "180deg" : "0deg" }}
                        className="flex items-center justify-center"
                      >
                        <button onClick={handleToggleLanguages}>
                          <IoIosArrowDown />
                        </button>
                      </motion.div>
                    </motion.div>
                  </div>
                  <AnimatePresence>
                    {showLanguages ? (
                      <motion.div
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: 100 }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{
                          duration: 0.3,
                        }}
                        layout="true"
                        className={`flex flex-col items-start justify-start 
                        w-full  
                        ${i18n.language === "en"
                            ? "pl-10"
                            : "pr-10"}`}
                      >
                        <div>
                          <p>English</p>
                        </div>
                        <div>
                          <p>العربية</p>
                        </div>
                      </motion.div>
                    ) : null}
                  </AnimatePresence>
                </motion.div>
                <div
                  className="flex flex-col gap-1 items-center justify-center w-full 
                absolute bottom-12"
                >
                  <Link to="/profile">
                    <p className="w-full text-start px-3 font-semibold hover:text-blue-400">
                      {user?.name.split(" ")[0]}
                    </p>
                  </Link>
                  {isAuthenticated ? (
                    <button
                      type="button"
                      onClick={handleLogout}
                      className="flex items-center justify-center w-full p-2 
                    bg-blue-800 rounded-full text-white"
                    >
                      {t("logout")}
                    </button>
                  ) : (
                    <button
                      type="button"
                      onClick={() => handlePopup("login")}
                      className="flex items-center justify-center w-full p-2 
                    bg-blue-800 rounded-full text-white"
                    >
                      {t("login")}
                    </button>
                  )}
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
